import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';
import { MOMENT_DATE_FORMAT } from '@app/_helpers';
import { CurrentPlan } from '@app/modules/trading/modules/mb-plans/providers/mb-plans.interface';
import * as moment from 'moment';

@Component({
  selector: 'app-broker-renewal-success',
  templateUrl: './broker-renewal-success.component.html',
  styleUrls: ['./broker-renewal-success.component.scss']
})
export class BrokerRenewalSuccessComponent implements OnInit {
  currentPlan: CurrentPlan;
  activePlanValidity: string;
  currentPlanName: string;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { planInfo: CurrentPlan },
    private dialogRef: MatDialogRef<BrokerRenewalSuccessComponent>,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.currentPlan = this.data.planInfo;
    this.activePlanValidity = moment(this.currentPlan.subscription_end_date).format(MOMENT_DATE_FORMAT);
    this.currentPlanName = this.currentPlan.plan.plan_name;
  }

  closeDialog() {
      this.dialogRef.close();
  }

  routeToTransaction() {
    this.router.navigate(['/trading/profile/transaction-history']);
    this.closeDialog();
  }

}
